import { AllergenIconType } from "./svgicon"

export const notPescotarian = 'Landdieren (≠pescotarisch)'
export const notVegetarian = 'Vlees, vis, vogel (≠vegetarisch)'
export const notVegan = 'Dierlijk (≠vegan)'

export const dietaryWishes = [notPescotarian, notVegetarian, notVegan]

// allergens come from Sharepoint
export const allergenIconId = (allergen: string): AllergenIconType | undefined => {
  switch (allergen) {
    case 'Celery':
      return 'allergen-celery'
    case 'Egg':
      return 'allergen-egg'
    case 'Fish':
      return 'allergen-fish'
    case 'Gluten':
      return 'allergen-gluten'
    case 'Lactose':
      return 'allergen-lactose'
    case 'Lupine':
      return 'allergen-lupine'
    case 'Milk':
      return 'allergen-milk'
    case 'Mollusks':
      return 'allergen-mollusks'
    case 'Mustard':
      return 'allergen-mustard'
    case 'Nuts':
      return 'allergen-nuts'
    case 'Peanuts':
      return 'allergen-peanuts'
    case 'Sesame':
      return 'allergen-sesame'
    case 'Crustaceans':
      return 'allergen-shellfish'
    case 'Soy':
      return 'allergen-soy'
    case 'Sulphur-dioxide':
      return 'allergen-sulphur-dioxide'
  }
}

export type DietaryWishes =
  | 'landdieren-pescotarisch'
  | 'vlees-vis-vogel-vegetarisch'
  | 'dierlijk-vegan'

export const dietaryWishesIconId = (dietaryWishes: DietaryWishes): AllergenIconType | undefined => {
  switch (dietaryWishes) {
    case 'landdieren-pescotarisch':
      return 'allergen-pescotarian'
    case 'dierlijk-vegan':
      return 'allergen-vegan'
    case 'vlees-vis-vogel-vegetarisch':
      return 'allergen-vegetarian'
  }
}
